import { module } from 'modujs'
import PhotoSwipe from 'photoswipe'

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)

        // UI
        this.$el = this.el

        // Events
        this.events = {
            click: {
                button: 'onButtonClick'
            }
        }

        this.iconClose = '<span class="c-text -label-button">Close</span>'
        this.arrowPrev = '<span class="pswp__button--arrow--inner"><span class="pswp__button--arrow--icon -base"><svg aria-hidden="true" focusable="false" class="svg-arrow-left"><use xlink:href="assets/images/sprite.svg#arrow-left"></use></svg></span><span class="pswp__button--arrow--icon -hover"><svg aria-hidden="true" focusable="false" class="svg-arrow-left"><use xlink:href="assets/images/sprite.svg#arrow-left"></use></svg></span></span>'
        this.arrowNext = '<span class="pswp__button--arrow--inner"><span class="pswp__button--arrow--icon -base"><svg aria-hidden="true" focusable="false" class="svg-arrow-right"><use xlink:href="assets/images/sprite.svg#arrow-right"></use></svg></span><span class="pswp__button--arrow--icon -hover"><svg aria-hidden="true" focusable="false" class="svg-arrow-right"><use xlink:href="assets/images/sprite.svg#arrow-right"></use></svg></span></span>'

        // Data
        this.gallery = JSON.parse(this.getData('gallery'))

        this.options = {
            dataSource: this.gallery,
            showHideAnimationType: 'fade',
            closeSVG: this.iconClose,
            arrowPrevSVG: this.arrowPrev,
            arrowNextSVG: this.arrowNext,
            counter: false,
            index: 0,
            bgOpacity: 1,
            padding: {
                top:    60,
                bottom: 60,
                left:   20,
                right:  20
            }
        }
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.showNotice = this.getData('notice') == 'false' ? false : true
    }

    destroy() {
        super.destroy()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener('resizeEnd', this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener('resizeEnd', this.onResizeBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
    }

    onButtonClick(e) {
        this.pswp = new PhotoSwipe(this.options)
        this.pswp.init()

        this.pswp.ui.registerElement({
            name: 'notice',
            isButton: false,
            tagName: 'p',
            html: this.showNotice ? 'For illustration purposes only. All rooms are unique, and these images may not represent your exact appointment.' : '',
            appendTo: 'root',
        });
    }

    ///////////////
    // Methods
    ///////////////
}
